export type Tema = "claro" | "escuro" | "sistema";

const CHAVE = "noesis:tema";

/**
 * O tema é um atributo em <html>, trocado sem recarregar. "sistema" remove o
 * atributo e devolve a decisão ao `prefers-color-scheme` — por isso são três
 * estados, e não um interruptor de dois.
 */
export function aplicarTema(tema: Tema): void {
  const raiz = document.documentElement;
  if (tema === "sistema") raiz.removeAttribute("data-tema");
  else raiz.setAttribute("data-tema", tema);
  try {
    localStorage.setItem(CHAVE, tema);
  } catch {
    // Navegador com armazenamento bloqueado ainda precisa exibir o app.
  }
}

export function temaGuardado(): Tema {
  try {
    const v = localStorage.getItem(CHAVE);
    if (v === "claro" || v === "escuro" || v === "sistema") return v;
  } catch {
    /* segue com o padrão */
  }
  return "sistema";
}
